import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AddUserReq, EditUserReq, User } from "../../models/user.model";

export const userActions = createActionGroup({
    source: 'User',
    events: {
        'Load Users': emptyProps(),
        'Load Users Success': props<{payload: User[]}>(),
        'Load Users Fail': emptyProps(),

        'Get User Info': props<{data: number}>(),
        'Get User Info Success': props<{payload: User}>(),
        'Get User Info Fail': emptyProps(),

        'Add User': props<{data: AddUserReq}>(),

        'Edit User': props<{data: EditUserReq}>(),

        'Delete User': props<{data: string}>(),
    }
})